import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import PublicFooter from './layout/publicFooter.vue';
import buyLink from './components/buyLink/index.vue';
import axios from 'axios';
import './assets/styles/index.scss'
import 'element-ui/lib/theme-chalk/index.css';
import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
Vue.config.productionTip = false
// axios.defaults.baseURL = '/prod-api'
// console.log(process.env.VUE_APP_BASE_API);

axios.defaults.baseURL = process.env.VUE_APP_BASE_API; 
// 创建并使用一个自定义实例（可选）
const request = axios.create({
  headers: {'Content-Type': 'application/json;charset=UTF-8'},
  // 其他自定义配置项...
});
Vue.prototype.$api = request; // 如果需要区分不同类型的请求，可以创建多个实例并分别挂载
Vue.use(ElementUI);
Vue.component("PublicFooter",PublicFooter)
Vue.component("buyLink",buyLink)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
